import React from 'react';
import { Input, Button, Select, Textarea, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ProductService } from 'services';
import { WhiteImage } from 'assets/img';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			name: '',
            sku: '',
            description: '',
            brand: '',
            model: '',
            category: '',
            subcategory: '',
            type: '',
            unit: '',
            color: '',
            size: '',
            price: '',
            currency: '',
            stock: '',
            attributes: ''
		},
		image: ''
	}

	componentDidMount() {
		if (this.props.item) {
			const item: any = this.props.item;

			this.setState({
				form: {
					...this.state.form,
					name: item?.name || '',
		            sku: item?.sku || '',
		            description: item?.description || '',
		            brand: item?.brand || '',
		            model: item?.model || '',
		            category: item?.category || '',
		            subcategory: item?.subcategory || '',
		            type: item?.type || '',
		            unit: item?.unit || '',
		            color: item?.color || '',
		            size: item?.size || '',
		            price: item?.price || '',
		            currency: item?.currency || '',
		            stock: item?.stock || '',
		            attributes: item?.attributes || '',
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.props.item) {
			await ProductService.update({
				...this.state.form,
				product_id: this.props.item?.id,
				hasFile: true,
				// @ts-ignore
				image: this.state.image?.value || '',
				user_id: this.props.user?.id
			});
			this.props.onClose();
			Globals.showSuccess("Se ha modificado el producto correctamente");
		}
		else {
			await ProductService.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore
				image: this.state.image?.value || '',
				user_id: this.props.user?.id
			});
			this.props.onClose();
			Globals.showSuccess("Se ha registrado el producto correctamente");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-product">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-12">
							<div className="container-image">
								<PaperClip
									formats={['png', 'jpg', 'jpeg']}
									value={this.state.image}
									width={1080}
									height={1080}
									onChange={(e: any) => {
										this.setState({
											image: e.target
										})
									}}>
									<div className="image">
										{/*
										// @ts-ignore */}
										<img src={this.state.image?.dataURL || (this.props.item?.image && Globals.generateS3(this.props.item?.image,Constants.S3.YES)) || WhiteImage} />
									</div>
								</PaperClip>
								<p>Subir imagen con una resolución máxima de 1080px*1080px</p>
							</div>
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.name }
								name="name"
								placeholder="Escribir"
								label="Nombre"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.sku }
								name="sku"
								placeholder="Escribir"
								label="SKU"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.brand }
								name="brand"
								placeholder="Escribir"
								label="Marca"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.model }
								name="model"
								placeholder="Escribir"
								label="Modelo"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Textarea
								rows={ 5 }
								value={ this.state.form.description }
								placeholder="Escribir"
								name="description"
								label="Descripción"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Textarea
								rows={ 5 }
								value={ this.state.form.attributes }
								placeholder="Escribir"
								name="attributes"
								label="Atributos"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.category }
								name="category"
								placeholder="Escribir"
								label="Categoría"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.subcategory }
								name="subcategory"
								placeholder="Escribir"
								label="Subcategoría"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.type }
								name="type"
								placeholder="Escribir"
								label="Tipo"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.unit }
								name="unit"
								placeholder="Escribir"
								label="Unidad"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.color }
								name="color"
								placeholder="Escribir"
								label="Colores"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.size }
								name="size"
								placeholder="Escribir"
								label="Tamaño"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								value={ this.state.form.price }
								name="price"
								placeholder="Escribir"
								label="Precio"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.currency }
								name="currency"
								placeholder="Escribir"
								label="Moneda"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.stock }
								name="stock"
								placeholder="Escribir"
								label="Stock"
								onChange={ (e: any) => this.change(e) } />
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalCreate);